import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faUser, 
  faBriefcase, 
  faComments, 
  faSearch, 
  faUsers, 
  faUserCog, 
  faClipboardList,
  faFileAlt,
  faHeart,
  faStore
} from '@fortawesome/pro-solid-svg-icons';

export const sideBarItemsCompany = [
  {
    id: 1,
    title: 'Restaurantes',
    icon: <FontAwesomeIcon icon={faStore} />,
    link: '/panel-empresa/restaurantes'
  },
  {
    id: 2,
    title: 'Trabajos',
    icon: <FontAwesomeIcon icon={faBriefcase} />,
    link: '/panel-empresa/trabajos'
  },
  {
    id: 3,
    title: 'Mensajes',
    icon: <FontAwesomeIcon icon={faComments} />,
    link: '/panel-empresa/inbox-empresa'
  },
  {
    id: 4,
    title: 'Explorador',
    icon: <FontAwesomeIcon icon={faSearch} />,
    link: '/panel-empresa/buscador-talentos'
  },
  {
    id: 5,
    title: 'Talentos',
    icon: <FontAwesomeIcon icon={faUsers} />,
    link: '/panel-empresa/mis-talentos'
  },
  {
    id: 6,
    title: 'Usuarios',
    icon: <FontAwesomeIcon icon={faUserCog} />,
    link: '/panel-empresa/usuarios',
    requiredRole: 'admin' // Only admins can manage users
  },
  {
    id: 7,
    title: 'Solicitudes',
    icon: <FontAwesomeIcon icon={faClipboardList} />,
    link: '/panel-empresa/solicitud-talentos'
  },
]

export const sideBarItemsEmployee = [
  {
    id: 1,
    title: 'Perfil',
    icon: <FontAwesomeIcon icon={faUser} />,
    link: '/panel-empleado/perfil-empleado'
  },
  {
    id: 2,
    title: 'Postulaciones',
    icon: <FontAwesomeIcon icon={faFileAlt} />,
    link: '/panel-empleado/postulaciones'
  },
  {
    id: 3,
    title: 'Mensajes',
    icon: <FontAwesomeIcon icon={faComments} />,
    link: '/panel-empleado/inbox-empleado'
  },
  {
    id: 4,
    title: 'Favoritos',
    icon: <FontAwesomeIcon icon={faHeart} />,
    link: '/panel-empleado/trabajos-favoritos'
  },
]